import { useQuery } from '@connectrpc/connect-query'
import { cn } from '@lib/utils'
import React, { FC, useEffect, useState } from 'react'
import { listPostsByUserID } from '@gen/api/v1/api-ApiService_connectquery'
import { Post } from '@gen/api/v1/api_pb'

interface ProfilePostsProps {
  userId: string
}

const ProfilePosts: FC<ProfilePostsProps> = ({ userId }) => {
  const [posts, setPosts] = useState<Post[]>([])
  const { data: listPostsRes } = useQuery(listPostsByUserID, { userId })

  useEffect(() => {
    if (listPostsRes?.posts) {
      setPosts(listPostsRes.posts)
    }
  }, [listPostsRes])

  return (
    <div
      className={cn(
        'grid gap-2 pb-8 w-full',
        posts && posts.length > 0
          ? 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
          : 'grid-cols-1',
      )}
    >
      {posts && posts.length > 0 ? (
        <>
          {posts.map((post) => (
            <div
              className="bg-secondary min-h-[240px] w-full"
              key={`post-${post}`}
            />
          ))}
        </>
      ) : (
        <div className="w-full">
          <p className="text-sm text-muted-foreground text-center w-full">
            No posts yet
          </p>
        </div>
      )}
    </div>
  )
}

export default ProfilePosts
